<ul class="nav navbar align-items-center">
  <ng-container *ngIf="empresa && estabelecimento">
    <li class="nav-item">
      <img [src]="empresa.imagem" alt="avatar" height="44" width="44" />
    </li>
    <li class="nav-item d-none d-md-block">
      <div class="company-container ml-1">
        <span class="company-name font-medium-2">{{ empresa.nome }}</span>
        <span class="company-branch font-small-3">{{ estabelecimento.nome }}</span>
      </div>
    </li>
  </ng-container>
</ul>